import {ChangeDetectionStrategy, Component, Input, OnInit} from "@angular/core";
import {Order, Product, Scope, StandardName} from "../../../store/state/order.state";
import {FormGroup} from "@angular/forms";
import {AuthenticationService} from "../../../authentication/authentication.service";
import {BaseSubFormComponent} from "../../../umbrella-common/components/base-sub-form.component";
import {BinaryQuestionData} from "../../../store/actions/order.actions";
import {StandardNamePipe} from "../../../umbrella-common/pipes/standard-name.pipe";
import {CompanyGeneralInfoFormService} from "./form-service/company-general-info.form.service";
import {TranslateService} from "@ngx-translate/core";
import {TranslationsHelperService} from "../../translations/translations-helper.service";
import {ClientCountryBasedConfig} from "../../../configuration/configuration.model";

@Component({
    selector: 'company-general-info',
    templateUrl: './company-general-info.template.html',
    styleUrls: ['./company-general-info.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CompanyGeneralInfoComponent extends BaseSubFormComponent implements OnInit {

	@Input() order: Order;
	@Input() product: Product;
	@Input() allScopes: { [accBody: string] : Scope[] };
	@Input() config: ClientCountryBasedConfig;

	form: FormGroup;
	iso9001Product: boolean;
	isClient: boolean;
	scopeDescriptionQuestion: BinaryQuestionData;
	employeesCountDescriptionQuestion: BinaryQuestionData;
	readonly companyDescriptionHint: string = 'company-general-info.company-description-hint';


	constructor(public formService: CompanyGeneralInfoFormService, private authService: AuthenticationService, private standardNamePipe: StandardNamePipe, private translateService: TranslateService,
				public translationHelper: TranslationsHelperService) {
		super(formService);
	}

	ngOnInit(): void {
		this.form = this.formService.buildSubForm(this.product.standard.name, this.totalSubForms(this.order), this.allScopes[this.product.accreditationBody], this.product);
		this.iso9001Product = this.product.standard.name == StandardName.ISO_9001;
		this.isClient = this.authService.isLoggedUserClient(true);
		const standard = this.standardNamePipe.transform(this.product.standard.name);
		this.scopeDescriptionQuestion = {
			type: undefined,
			question: this.translateService.instant("company-general-info.scope-question-description", {standard: standard}),
			commentMandatory: true,
			commentMandatoryWithAnswerValueEqualTo: false
		};

		this.employeesCountDescriptionQuestion = {
			type: undefined,
			question: this.translateService.instant("company-general-info.employees-count-description"),
			commentMandatory: true,
			commentMandatoryWithAnswerValueEqualTo: true
		};
	}


	getFormKey(): string {
		return this.product.standard.name;
	}

	shouldDisableRadio(controlName: string): boolean {
		const control = this.formService.getFormControl(this.product.standard.name, controlName);
		return control != null ? control.disabled : false;
	}

	translationExists(subject: string): boolean {
		return this.translationHelper.translationExists(this.product.standard.name, subject, false);
	}

	getTranslationText(subject: string): string {
		return this.translationHelper.getTranslation(this.product.standard.name, subject, false);
	}

	protected iso27701HasItsOwnSubForm(): boolean {
		return false;
	}

	showPartEmployee() {
		if (!this.config) return true; // TODO: temp solution before NL implementation
		return this.config.order.showPartTimeEmployees
	}

	showCatastrophicRisk() {
		return this.config.order.showIso9001CatastrophicRisk
	}
}
